<template>
  <div
    class="custom-player-container"
    :class="{
      'custom-player-container__electron': isElectron,
      'custom-player-container__h5': isH5,
      'custom-player-container__landscape': isLandscape,
      'custom-player-container__component': isComponent,
    }"
  >
    <div
      v-show="!showNetworkError"
      class="dplayer-wrapper"
      :class="{
        'dplayer-wrapper__full': fullScreenStatus && (isH5 || openAiMode),
        'dplayer-hide-controller ': !isShowControls,
        'dplayer-mobile dplayer ': isH5,
      }"
      ref="dplayerContainer"
    ></div>
    <!-- 字幕覆盖层 -->
    <SubtitleOverlay
      ref="subtitleOverlay"
      :subtitleUrl="subtitleUrl"
      :currentTime="currentTime"
      :isFullScreen="fullScreenStatus"
      :controlsVisible="isShowControls"
      @subtitleToggle="subtitleActive = $event"
    />
    <!-- 顶部 -->
    <template v-if="isShowTop">
      <div
        v-if="isElectron"
        class="electron-play-header"
        :class="{
          'play-header__full': fullScreenStatus && (isH5 || openAiMode),
          'play-header__show': isShowControls && !isScreenshot,
        }"
        @dblclick.self="handleDbclick"
      >
        <!-- 普通看课模式 -->
        <template v-if="!openAiMode">
          <ToolBar
            v-if="!fullScreenStatus"
            class="tool-bar"
            :beforeClose="closeWin"
          />
          <div class="name">
            {{ title || "" }}
          </div>
        </template>
        <div
          class="operate-wrap"
          :class="{ 'is-win': isWin && !fullScreenStatus && !openAiMode }"
        >
          <button v-if="!fullScreenStatus" class="top-btn">
            <img @click="handleOnTop" :src="topIcon" alt="" />
          </button>
          <button @click="networkTest" class="network-test-btn">
            <img
              src="../../../../../assets/images/reply/network-test.png"
              alt=""
            />
          </button>
        </div>
      </div>
      <div
        v-else-if="!fullScreenStatus"
        class="play-header"
        :class="{
          'play-header__full': fullScreenStatus,
          'play-header__show': isShowControls && !isScreenshot,
        }"
      >
        <div class="back-wrap">
          <div class="back-btn" v-if="showBack" @click="$emit('back')">
            <img src="../../../../../assets/images/reply/back.png" alt="" />
          </div>
        </div>
        <div class="name">
          {{ title || "" }}
        </div>
      </div>
    </template>

    <div
      v-if="!isH5"
      class="paly-pause-icon-box"
      :class="{
        'paly-pause-icon-box__show': isShowPlayPauseIcon,
      }"
    >
      <img :src="videoPlayPauseIcon" alt="" />
    </div>
    <!-- logo -->
    <div
      v-if="orgName"
      class="logo-container"
      :class="{
        'logo-container__full': fullScreenStatus && (isH5 || openAiMode),
      }"
    >
      <img
        class="logo"
        :src="faviconUrl"
        alt=""
      />
      <div class="divider"></div>
      <div class="org-name">{{ orgName }}</div>
    </div>
    <!-- notice -->
    <div
      class="notice-box"
      :class="{
        'notice-box__full': fullScreenStatus,
      }"
      v-if="notice"
    >
      {{ notice }}
    </div>
    <!-- 控制区 -->
    <div
      class="player-controls"
      :class="{
        'player-controls__full': fullScreenStatus && (isH5 || openAiMode),
        'player-controls__show': isShowControls && !isScreenshot,
      }"
    >
      <div class="last-play-position">
        <template v-if="startTime && isShowReply">
          <span>已自动定位至上次观看位置</span>
          <div class="reply-btn" @click="handleReply">从头学</div>
        </template>
      </div>
      <div class="progress-bar-box">
        <!-- <div class="current-time time">{{ formatTime(currentTime) }}</div> -->
        <DraggableProgressBar
          ref="progressBar"
          class="progress-bar"
          :value="currentProgress"
          :initCurrentTime="currentTime"
          :initDuration="duration"
          :isLandscape="isLandscape"
          @change="seekTo"
        ></DraggableProgressBar>
        <!-- <div class="total-time time">{{ formatTime(duration) }}</div> -->
      </div>
      <div class="other-controls">
        <div class="left">
          <div class="play-pause-btn">
            <img @click="togglePlayPause" :src="playPauseIcon" alt="" />
          </div>
          <Volume
            ref="volume"
            :value="volume"
            :isLandscape="isLandscape"
            @input="changeVolume"
            :maxVolume="maxVolume"
          ></Volume>
        </div>
        <div class="right">
          <div v-if="!isH5" class="operate-item">
            <img
              @click="
                videoScreenShot({
                  type: 'screenshot',
                  title: '截图',
                })
              "
              src="../../../../../assets/images/reply/camera.png"
              alt=""
            />
          </div>
          <video-mark-popover
            v-if="!isH5"
            ref="markPopover"
            class="operate-item"
            @select="handleMarkSelect"
          />
          <div v-if="isElectron" class="cut-btn">
            <img
              @click="handleScreenshot"
              src="../../../../../assets/images/reply/cut.png"
              alt=""
            />
          </div>
          <div class="back-btn">
            <img
              @click="handleBackFive"
              src="../../../../../assets/images/reply/back_five.png"
              alt=""
            />
          </div>
          <div class="forward-btn">
            <img
              @click="handleForwardFive"
              src="../../../../../assets/images/reply/forward_five.png"
              alt=""
            />
          </div>
          <Speed
            class="speed"
            ref="speed"
            :value="playbackSpeed"
            :isLandscape="isLandscape"
            @change="changeSpeed"
          ></Speed>
          <!-- 字幕CC按钮 -->
          <div
            v-if="subtitleSwitch === 1"
            class="subtitle-cc-btn-wrap"
            @click="handleCCClick"
          >
            <svg viewBox="0 0 24 24" width="30" height="30" :fill="subtitleCCColor">
              <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12zM7.5 13h2c.28 0 .5-.22.5-.5V12h1.5v1c0 .83-.67 1.5-1.5 1.5h-2c-.83 0-1.5-.67-1.5-1.5v-3C6.5 9.17 7.17 8.5 8 8.5h2c.83 0 1.5.67 1.5 1.5v1H10v-.5c0-.28-.22-.5-.5-.5h-2c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5zm7 0h2c.28 0 .5-.22.5-.5V12h1.5v1c0 .83-.67 1.5-1.5 1.5h-2c-.83 0-1.5-.67-1.5-1.5v-3c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v1H17v-.5c0-.28-.22-.5-.5-.5h-2c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5z" />
            </svg>
          </div>
          <div class="full-screen-btn">
            <img @click="toggleFullScreen" :src="screenIcon" alt="" />
          </div>
        </div>
      </div>
      <!-- 自定义标记标题弹窗 -->
      <custom-mark-title
        class="custom-mark-title"
        ref="customMarkTitle"
        @save="handleCustomMarkSave"
      />
    </div>
    <!-- 购物车 -->
    <shopping-cart
      :lessonId="lessonInfo.id"
      @toggleFullScreen="toggleFullScreen"
      @changeFullScreenStatus="changeFullScreenStatus"
      :dplayer="dplayer"
      :class="isH5 && !fullScreenStatus ? '' : 'replay-cart'"
      :fullScreenStatus="fullScreenStatus"
    />

    <!-- 网络未连接 -->
    <div
      v-show="showNetworkError"
      id="network-error-mask"
      class="network-error-mask"
    >
      <div class="cont-wrap">
        <p class="tips">网络未连接，请检查网络设置</p>
        <div class="operate-wrap">
          <button class="test-btn" @click="networkTest">在线检测</button>
          <button class="refresh-btn" @click="refreshRetry">
            <i class="el-icon-refresh-right"></i>
            <span>刷新重试</span>
          </button>
        </div>
      </div>
    </div>

    <!-- loading -->
    <img
      v-if="videoLoading"
      class="video-loading-img"
      src="../../../../../assets/images/icon/video-loading.gif"
    />
  </div>
</template>

<script>
import { EventBus } from "@saas/components/src/utils/event-bus";
import CustomMarkTitle from "./CustomMarkTitle.vue";
import SubtitleOverlay from "./SubtitleOverlay.vue";
import { convertBase64ToFile, videoMarkPopover } from "@saas/components";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import DraggableProgressBar from "./DraggableProgressBar.vue";
import Volume from "./Volume.vue";
import Speed from "./Speed.vue";
import {
  isH5,
  isHXApp,
  isMobile,
  ShoppingCart,
  ToolBar,
  getCdnUrl,
} from "@saas/components/src";
export default {
  name: "CustomPlayer",
  components: {
    DraggableProgressBar,
    Volume,
    Speed,
    ShoppingCart,
    ToolBar,
    videoMarkPopover,
    CustomMarkTitle,
    SubtitleOverlay,
  },
  props: {
    noteComponentId: {
      type: [String, Number],
      default: null,
    },
    openAiMode: {
      type: Boolean,
      default: false,
    },
    lessonInfo: {
      type: Object,
      default: () => {},
    },
    // 开始播放时长
    startTime: {
      type: Number,
      default: 0,
    },
    // 跳转播放位置
    jumpPlayTime: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: "",
    },
    orgName: {
      type: String,
      default: "",
    },
    // 展示返回按钮
    showBack: {
      type: Boolean,
      default: false,
    },
    fullScreenStatus: {
      type: Boolean,
      default: false,
    },
    isShowTop: {
      type: Boolean,
      default: true,
    },
    isComponent: {
      type: Boolean,
      default: false,
    },
    urlProgressTime: {
      type: Number,
      default: null,
    }, //页面路径参数:播放位置
    subtitleUrl: {
      type: String,
      default: "",
    },
    subtitleSwitch: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      videoLoading: false,
      showNetworkError: false,
      loadingTimeout: null,
      LOADING_TIMEOUT: 15 * 1000,
      playIcon: require("../../../../../assets/images/reply/play.png"),
      pauseIcon: require("../../../../../assets/images/reply/pause.png"),
      fullScreenIcon: require("../../../../../assets/images/reply/full_screen.png"),
      exitFullScreenIcon: require("../../../../../assets/images/reply/exit_full_screen.png"),
      onTopIcon: require("../../../../../assets/images/reply/top.png"),
      noOnTopIcon: require("../../../../../assets/images/reply/no_top.png"),
      dplayer: null,
      isPlaying: false,
      // isFullScreen: false,
      // 播放进度
      currentProgress: 0,
      // 音量
      volume: 0,
      // 播放速度
      playbackSpeed: 1,
      // 当前时长
      currentTime: 0,
      // 总时长
      duration: 0,
      // 控制栏显示隐藏
      isShowControls: true,
      // 操作倒计时
      activityTimer: null,
      // 从头学展示倒计时
      replyTimer: null,
      // 是否展示从头学
      isShowReply: false,
      isH5: isMobile(),
      // 是否截图中
      isScreenshot: false,
      screenShot: null,
      // 是否置顶
      isOnTop: false,
      // 最大音量
      maxVolume: 100,
      isElectron: window.isElectron,
      // 视频是否加载完
      isLoaded: false,
      notice: "",
      noticeTimer: null,
      isShowPlayPauseIcon: false,
      isShowPlayPauseIconTimer: null,
      // 音频信息
      audioInfo: {
        context: null,
        source: null,
        gain: null,
        media: null,
        amplify: (multiplier) => {
          this.audioInfo.gain.gain.value = multiplier;
        },
        getAmpLevel: () => {
          return this.audioInfo.gain.gain.value;
        },
      },
      // 是否是新的视频
      isNewVideo: true,
      isLandscape:
        isMobile() && window?.screen?.orientation?.type?.includes("landscape"),
      isWin: false,
      faviconUrl: getCdnUrl("/cdn/static/images/favicon.ico"),
      subtitleActive: true,
    };
  },
  watch: {
    startTime: {
      handler(newValue) {
        if (newValue && !this.urlProgressTime) {
          this.isShowReply = true;
        } else {
          this.isShowReply = false;
        }
        if (this.dplayer) {
          // 优先页面路径time参数
          if (newValue && !this.urlProgressTime) {
            this.dplayer.seek(newValue);
          } else {
            this.dplayer.seek(0);
          }
        }
      },
      immediate: true,
    },
    jumpPlayTime: {
      handler(newValue) {
        this.isShowReply = false;
        if (this.dplayer) {
          if (newValue) {
            this.dplayer.seek(newValue);
          } else {
            this.dplayer.seek(0);
          }
          this.dplayer.play();
        }
      },
      immediate: true,
    },
    urlProgressTime: {
      handler(newValue) {
        this.isShowReply = false;
        if (this.dplayer) {
          if (newValue) {
            this.dplayer.seek(newValue);
          }
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(["user"]),
    curNoteComponentId() {
      if (this.openAiMode) {
        return `ai-mode-note`;
      } else if (this.fullScreenStatus && !window.isElectron) {
        return `web-fullscreen-note`;
      } else {
        return this.noteComponentId;
      }
    },
    videoPlayPauseIcon() {
      return this.isPlaying ? this.playIcon : this.pauseIcon;
    },
    playPauseIcon() {
      return this.isPlaying ? this.playIcon : this.pauseIcon;
    },
    screenIcon() {
      return this.fullScreenStatus
        ? this.exitFullScreenIcon
        : this.fullScreenIcon;
    },
    topIcon() {
      return this.isOnTop ? this.onTopIcon : this.noOnTopIcon;
    },
    // 是否访录频
    isVisual() {
      return this.lessonInfo.risk_control_switch === 1;
    },
    subtitleCCColor() {
      return this.subtitleActive ? '#13ce66' : 'rgba(255,255,255,0.6)';
    },
  },
  mounted() {
    this.initDplay();
    this.startListening();
    this.initStyle();
    if (window.isElectron && window.isWin) {
      this.isWin = window?.isWin();
    }
    EventBus.$off(`notice-video-screen-shot`);
    EventBus.$on(`notice-video-screen-shot`, this.handleNoticeVideoScreenShot);
    EventBus.$off(`notice-insert-mark-block`);
    EventBus.$on(`notice-insert-mark-block`, this.handleNoticeInsertMarkBlock);
    EventBus.$off(`notice-jump-play-time`);
    EventBus.$on(`notice-jump-play-time`, this.handleJumpPlayTime);
  },
  beforeDestroy() {
    const dom = this.$refs.dplayerContainer;
    document.removeEventListener("mousemove", this.onActivety);
    document.removeEventListener("touchstart", this.onActivety);
    document.removeEventListener("touchmove", this.onActivety);
    document.removeEventListener("keydown", this.onkeydown);
    document.removeEventListener("click", this.onActivety);
    window.removeEventListener("orientationchange", this.onorientationchange);
    clearTimeout(this.activityTimer);
    this.dplayer.destroy();
  },
  methods: {
    ...mapMutations("learningRecord", ["setLastLesson", "delLastLesson"]),
    handleDbclick() {
      console.log("handleDbclick--windows");
      window.ReplyElectronApi.maxSizeWin();
    },
    closeWin() {
      EventBus.$emit("closeReplyWinByToolBar");
    },
    handleNoticeVideoScreenShot() {
      console.log("====handleNoticeVideoScreenShot");

      this.videoScreenShot({
        type: "screenshot",
        title: "截图",
      });
    },
    handleNoticeInsertMarkBlock(data) {
      console.log("data=====", data);

      this.videoScreenShot({
        ...data,
        title: data.content,
      });
    },
    handleJumpPlayTime(time) {
      this.isShowReply = false;
      if (this.dplayer) {
        if (time) {
          this.dplayer.seek(time);
        } else {
          this.dplayer.seek(0);
        }
        if (this.dplayer.video.duration > time) {
          this.dplayer.play();
        }
      }
    },
    handleCustomMarkSave(title) {
      this.videoScreenShot({
        type: "custom",
        title,
        id: 1,
      });
    },
    handleMarkSelect(data) {
      if (data.type === "custom") {
        this.$refs.customMarkTitle.handleShow();
      } else {
        this.videoScreenShot(data);
      }
    },
    // 视频截图
    videoScreenShot({ type, title, id }) {
      const video = document.querySelector(
        ".dplayer-video.dplayer-video-current"
      );
      if (!video || !video.src) {
        this.$showToast(
          `${type === "screenshot" ? "截图" : "标记"}失败，请重新尝试`
        );
      } else {
        const cvs = document.createElement("canvas");
        const ctx = cvs.getContext("2d");
        cvs.width = video.videoWidth;
        cvs.height = video.videoHeight;
        let time = this.currentTime;
        ctx.drawImage(video, 0, 0, cvs.width, cvs.height);
        if (this.$refs?.progressBar?.currentTime) {
          time = this.$refs.progressBar.currentTime;
        }
        time = Math.floor(time);
        const dataURL = cvs.toDataURL("image/png");
        const file = convertBase64ToFile(dataURL, `screen-shot-${time}s.png`);
        this.$showToast(`${type === "screenshot" ? "截图" : "标记"}成功`);
        if (type === "custom" && this.$refs?.customMarkTitle) {
          this.$refs.customMarkTitle.handleClose();
        }
        console.log("noteComponentId", this.curNoteComponentId);
        const data = {
          file,
          time,
          title,
          type,
          id,
          noteComponentId: this.curNoteComponentId,
        };
        if (this.curNoteComponentId === "video-play-note") {
          EventBus.$emit("video-play-page-change-tab-to-note", data);
        } else {
          if (data.type === "screenshot") {
            EventBus.$emit(
              `handle-insert-video-screen-shot-${data.noteComponentId}`,
              {
                ...data,
                url: "",
              }
            );
            if (this.curNoteComponentId === "web-fullscreen-note") {
              EventBus.$emit(
                `handle-insert-video-screen-shot-video-play-note`,
                {
                  ...data,
                  url: "",
                }
              );
            }
          } else {
            const { id, time, title, file, type } = data;
            EventBus.$emit(`handle-insert-mark-block-${data.noteComponentId}`, {
              type,
              time,
              content: title,
              file,
              imgUrl: "",
            });
            if (this.curNoteComponentId === "web-fullscreen-note") {
              EventBus.$emit(`handle-insert-mark-block-video-play-note`, {
                type,
                time,
                content: title,
                file,
                imgUrl: "",
              });
            }
          }
        }
      }
    },
    refreshRetry() {
      this.showNetworkError = false;
      this.dplayer.play();
    },
    showLoadingMask() {
      this.hideLoadingGif();
      this.dplayer.pause();
      this.showNetworkError = true;
    },
    networkTest() {
      if (!window?.navigator?.onLine) {
        this.$showToast("网络未连接，请稍后再试");
        return false;
      }
      if (window?.ipcRenderer) {
        window.ipcRenderer.send("create-new-win", {
          key: "networkTest",
          url: `/network-test?lessonId=${this.lessonInfo.id}`,
          data: {
            lessonId: this.lessonInfo.id,
          },
        });
      }
    },
    changeFullScreenStatus(status) {
      this.fullScreenStatus = status;
    },
    initStyle() {
      // 想把播放器自适应放在页面中间
      const documentRatio = window.innerWidth / window.innerHeight;
      const dplayRatio =
        this.$refs.dplayerContainer.offsetWidth /
        this.$refs.dplayerContainer.offsetHeight;
      if (documentRatio > dplayRatio) {
        this.$refs.dplayerContainer.style.height = "100%";
        this.$refs.dplayerContainer.style.width = "auto";
      } else {
        this.$refs.dplayerContainer.style.width = "100%";
        this.$refs.dplayerContainer.style.height = "auto";
      }
    },
    // 获取指定id设备的视频流
    getInitStream(source, audio) {
      return new Promise((resolve, _reject) => {
        // 获取指定窗口的媒体流
        // 此处遵循的是webRTC的接口类型  暂时TS类型没有支持  只能断言成any
        navigator.mediaDevices
          .getUserMedia({
            audio: audio
              ? {
                  mandatory: {
                    chromeMediaSource: "desktop",
                  },
                }
              : false,
            video: {
              mandatory: {
                chromeMediaSource: "desktop",
                chromeMediaSourceId: source.id,
              },
            },
          })
          .then((stream) => {
            resolve(stream);
          })
          .catch((error) => {
            console.log(error);
            resolve(null);
          });
      });
    },
    showLoadingGif() {
      this.videoLoading = true;
    },
    hideLoadingGif() {
      this.videoLoading = false;
    },
    initDplay() {
      if (window.isElectron) {
        this.showLoadingGif();
      }
      this.dplayer = new window.DPlayer({
        container: this.$refs.dplayerContainer,
        video: {},
        hotkey: false,
        screenshot: true,
      });
      this.volume = this.dplayer.video.volume * 100;
      this.dplayer.on("error", () => {
        if (window.isElectron) {
          console.log("====error");
          this.showLoadingMask();
        }
      });
      this.dplayer.on("waiting", () => {
        if (window.isElectron) {
          console.log("=======waiting");
          this.showLoadingGif();
          this.loadingTimeout = setTimeout(() => {
            this.showLoadingMask();
          }, this.LOADING_TIMEOUT);
        }
      });
      // 监听播放事件
      this.dplayer.on("play", () => {
        this.dplayer.speed(this.playbackSpeed);
        this.isPlaying = true;
        this.isShowPlayPauseIcon = true;
        clearTimeout(this.isShowPlayPauseIconTimer);
        this.isShowPlayPauseIconTimer = setTimeout(() => {
          this.isShowPlayPauseIcon = false;
        }, 500);

        if (this.isPlaying && this.user?.user_id) {
          console.log("setLastLesson====LastLesson");
          // 记录为上次学到的课时
          let { course_id, unit_id, id } = this.lessonInfo;
          this.setLastLesson({
            user_id: this.user.user_id,
            ...this.lessonInfo,
            lesson_id: id,
          });
        }

        // if (this.isNewVideo) {
        //   this.isNewVideo = false;
        //   this.amplifyMedia(this.dplayer.video, 10);
        // }
        // this.volume = this.dplayer.video.volume * 100;
      });
      // 监听播放时间更新事件
      this.dplayer.on("timeupdate", () => {
        if (this.loadingTimeout) {
          this.hideLoadingGif();
          clearTimeout(this.loadingTimeout);
        }
        this.currentTime = this.dplayer.video.currentTime;
        this.currentProgress =
          this.dplayer.video.currentTime / this.dplayer.video.duration;
      });
      // 监听视频时长更新事件
      this.dplayer.on("durationchange", () => {
        this.currentTime = this.dplayer.video.currentTime;
        this.duration = this.dplayer.video.duration;
        this.$emit("videoDurationChange", this.duration);
        this.currentProgress =
          this.dplayer.video.currentTime / this.dplayer.video.duration;
      });
      this.dplayer.on("loadeddata", () => {
        this.onActivety();
        this.isLoaded = true;
        if (window.isElectron) {
          this.hideLoadingGif();
          this.dplayer.play();
        }
        // 初始化视频播放时间： 优先页面路径time参数
        if (this.urlProgressTime || this.startTime) {
          let time = this.urlProgressTime || this.startTime;
          this.dplayer.seek(time);
          clearTimeout(this.replyTimer);
          this.replyTimer = setTimeout(() => {
            this.isShowReply = false;
          }, 3000);
        }
      });
      // 监听进度条拖动事件
      this.dplayer.on("progress", () => {
        // console.log("progress");
        // console.log(this.dplayer);
      });
      // 监听播放速度变化事件
      this.dplayer.on("ratechange", () => {
        // console.log("ratechange");
      });
      this.dplayer.on("pause", () => {
        // console.log("pause");
        this.isPlaying = false;
        this.isShowPlayPauseIcon = true;
        clearTimeout(this.isShowPlayPauseIconTimer);
        this.isShowPlayPauseIconTimer = setTimeout(() => {
          this.isShowPlayPauseIcon = false;
        }, 500);

        if (
          this.user?.user_id &&
          this.duration === (this.currentTime || this.dplayer.video.currentTime)
        ) {
          console.log("delLastLesson====LastLesson");
          // 移除上次学习课时
          this.delLastLesson({
            user_id: this.user.user_id,
            course_id: this.lessonInfo.course_id,
            lesson_id: this.lessonInfo.id,
          });
        }
      });
      this.dplayer.on("seeked", () => {
        // console.log("seeked");
      });
      this.dplayer.on("seeking", () => {
        // console.log("seeking");
      });
      this.dplayer.on("stalled", () => {
        // console.log("stalled");
      });
      // this.dplayer.on("webfullscreen", () => {
      //   this.isFullScreen = true;
      // });
      // this.dplayer.on("webfullscreen_cancel", () => {
      //   this.isFullScreen = false;
      // });
      this.dplayer.on("resize", () => {
        // console.log(this.$refs.dplayerContainer);
        // console.log("resize");
        // console.log(this.dplayer);
      });
      this.dplayer.on("notice_show", (val) => {
        if (val.startsWith("快进") || val.startsWith("快退")) {
          this.notice = val;
          clearTimeout(this.noticeTimer);
          this.noticeTimer = setTimeout(() => {
            this.notice = "";
          }, 2000);
        }
      });
    },
    // handleFullScreenChange() {
    //   if (
    //     document.fullscreenElement ||
    //     document.webkitFullscreenElement ||
    //     document.mozFullScreenElement ||
    //     document.msFullscreenElement
    //   ) {
    //     this.isFullScreen = true;
    //   } else {
    //     this.isFullScreen = false;
    //   }
    //   // if (this.isH5 && !this.isLandscape) {
    //   //   // 设置横屏样式
    //   //   document.documentElement.style.transform = "rotate(-90deg)";
    //   //   document.documentElement.style.width = "100vh";
    //   //   document.documentElement.style.height = "100vw";
    //   //   document.documentElement.style.position = "absolute";
    //   //   document.documentElement.style.top = "-100vh";
    //   //   document.documentElement.style.left = "0";
    //   // }
    // },
    // 监听dom元素的所有的操作事件
    startListening() {
      const dom = this.$refs.dplayerContainer;
      document.addEventListener("mousemove", this.onActivety);
      document.addEventListener("touchstart", this.onActivety);
      document.addEventListener("touchmove", this.onActivety);
      document.addEventListener("keydown", this.onkeydown);
      document.addEventListener("click", this.onActivety);
      // document.addEventListener(
      //   "fullscreenchange",
      //   this.handleFullScreenChange
      // );
      // document.addEventListener(
      //   "webkitfullscreenchange",
      //   this.handleFullScreenChange
      // );
      // document.addEventListener(
      //   "mozfullscreenchange",
      //   this.handleFullScreenChange
      // );
      // document.addEventListener(
      //   "MSFullscreenChange",
      //   this.handleFullScreenChange
      // );
      // 监听横竖屏切换
      window.addEventListener("orientationchange", this.onorientationchange);
    },
    onorientationchange() {
      this.isLandscape =
        this.isH5 && window.screen.orientation.type.includes("landscape");
    },
    onkeydown(e) {
      if (e.keyCode === 32) {
        this.dplayer.toggle();
      }
      if (e.keyCode === 37) {
        this.dplayer.seek(this.dplayer.video.currentTime - 5);
      } else if (e.keyCode === 39) {
        this.dplayer.seek(this.dplayer.video.currentTime + 5);
      }
      this.onActivety();
    },
    onActivety() {
      this.isShowControls = true;
      clearTimeout(this.activityTimer);
      // if (this.isPlaying) {
      //   this.activityTimer = setTimeout(() => {
      //     this.$refs.volume.isShow = false;
      //     this.$refs.speed.isShow = false;
      //     this.isShowControls = false;
      //   }, 5000);
      // }
      this.activityTimer = setTimeout(() => {
        // 自定义标记弹窗显示时-不自动隐藏控制栏
        if (!this.$refs?.customMarkTitle?.isShow) {
          this.$refs.volume.isShow = false;
          this.$refs.speed.isShow = false;
          if (this.$refs?.markPopover) {
            this.$refs.markPopover.isShow = false;
          }
          this.isShowControls = false;
        }
      }, 5000);
    },
    // 从头学展示计时
    handleReplyTimer() {
      this.replyTimer = setTimeout(() => {
        this.isShowReply = false;
      }, 3000);
    },
    // 隐藏 展示 notice
    handleShowHideNotice(isShow) {
      const dom = this.$refs.dplayerContainer;
      if (dom) {
        const noticeDom = dom.querySelector(".dplayer-notice");
        if (noticeDom) {
          if (isShow) {
            noticeDom.style.display = "block";
          } else {
            noticeDom.style.display = "none";
          }
        }
      }
    },
    // 从头学
    handleReply() {
      // this.handleShowHideNotice(false);
      // this.dplayer.seek(0);
      // this.dplayer.play();
      this.$emit("afresh");
      this.isShowReply = false;
    },
    // CC按钮点击
    handleCCClick() {
      const overlay = this.$refs.subtitleOverlay;
      if (!overlay) return;
      // 没有字幕URL 或 字幕数据为空且不在加载中 → 字幕尚未生成
      if (!this.subtitleUrl || (!overlay.subtitleList.length && !overlay.loading)) {
        this.$message.info("字幕生成中，请稍后再试");
        return;
      }
      overlay.toggleSubtitle();
    },
    // 播放暂停
    togglePlayPause() {
      this.dplayer.toggle();
    },
    handleOnTop() {
      if (this.isElectron && window.getIsAlwaysOnTop) {
        window.getIsAlwaysOnTop().then((res) => {
          console.log(res);
          this.isOnTop = !res;
          window.toggleOnTop(!res);
        });
      }
    },
    // 截屏
    async handleScreenshot() {
      this.isScreenshot = true;
      const prePlayStatus = this.isPlaying;

      if (this.isPlaying) {
        this.dplayer.pause();
      }
      if (this.isElectron) {
        if (window.screenCaptureSwitch) {
          window.screenCaptureSwitch({
            isEnter: true,
            disableRecord: false,
          });
        }
        // 下面这两块自己考虑
        const sources = await window.getDesktopCapturerSelf(); // 这里返回的是设备上的所有窗口信息
        // 这里可以对`sources`数组下面id进行判断  找到当前的electron窗口  这里为了简单直接拿了第一个
        const stream = await this.getInitStream(sources);
        // eslint-disable-next-line no-undef
        new screenShotPlugin({
          enableWebRtc: true, // 启用webrtc
          screenFlow: stream, // 传入屏幕流数据
          level: 999999,
          toolPosition: "right",
          completeCallback: () => {
            console.log("截图完成");
            if (prePlayStatus) {
              this.dplayer.play();
            }
            this.isScreenshot = false;
            if (window.screenCaptureSwitch) {
              window.screenCaptureSwitch({
                isEnter: true,
                disableRecord: this.isVisual,
              });
            }
          },
          closeCallback: () => {
            console.log("截图取消");
            if (prePlayStatus) {
              this.dplayer.play();
            }
            this.isScreenshot = false;
            if (window.screenCaptureSwitch) {
              window.screenCaptureSwitch({
                isEnter: true,
                disableRecord: this.isVisual,
              });
            }
          },
        });
      } else {
        new window.screenShotPlugin({
          enableWebRtc: true,
          completeCallback: () => {
            console.log("截图完成");
            if (prePlayStatus) {
              this.dplayer.play();
            }
            this.isScreenshot = false;
          },
          closeCallback: () => {
            console.log("截图取消");
            if (prePlayStatus) {
              this.dplayer.play();
            }
            this.isScreenshot = false;
          },
        });
      }
    },
    seekTo(val) {
      const seekTime = val * this.dplayer.video.duration;
      this.dplayer.seek(seekTime);
    },
    playToSeekTime(seekTime) {
      this.dplayer.seek(seekTime);
    },
    // 快退5秒
    handleBackFive() {
      this.dplayer.seek(this.dplayer.video.currentTime - 5);
    },
    // 快进5秒
    handleForwardFive() {
      this.dplayer.seek(this.dplayer.video.currentTime + 5);
    },
    // 切换全屏
    toggleFullScreen() {
      this.$emit("toggleFullScreen");
      // this.isFullScreen = !this.isFullScreen;
      // if (this.isFullScreen) {
      //   this.dplayer.fullScreen.cancel("web");
      // } else {
      //   this.dplayer.fullScreen.request("web");
      // }
    },
    // 格式化时间 00:00:00 ，不够小时不显示
    formatTime(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = Math.floor(seconds % 60);
      return `${hours < 10 ? "0" + hours : hours}:${
        minutes < 10 ? "0" + minutes : minutes
      }:${secs < 10 ? "0" + secs : secs}`;
    },
    // 改变音量
    changeVolume(val) {
      // this.handleShowHideNotice(false);
      console.log("val>>>>>>>", val / this.maxVolume);
      this.dplayer.volume(val / this.maxVolume);
    },
    // 改变播放速度
    changeSpeed(val) {
      this.playbackSpeed = val;
      this.dplayer.speed(val);
    },
    destroyAudioProcessing() {
      console.log(this.audioInfo);
      if (this.audioInfo.source && this.audioInfo.gain) {
        this.audioInfo.source.disconnect();
        this.audioInfo.gain.disconnect();
        this.audioInfo.context.close();
        // this.audioInfo.source = null;
        // this.audioInfo.gain = null;
        // this.audioInfo.media = null;
      }
    },
    amplifyMedia(mediaElem, multiplier) {
      this.destroyAudioProcessing();
      var context =
        this.audioInfo.context ||
        new (window.AudioContext || window.webkitAudioContext)();
      this.audioInfo.context = context;
      this.audioInfo.source = context.createMediaElementSource(mediaElem);
      this.audioInfo.gain = context.createGain();
      this.audioInfo.media = mediaElem;
      this.audioInfo.source.connect(this.audioInfo.gain);
      this.audioInfo.gain.connect(context.destination);
      this.audioInfo.amplify(multiplier);
    },
  },
};
</script>

<style lang="scss" scoped>
.network-error-mask {
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  .cont-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  width: 100%;
  height: 100%;
  background: url("../../../../../assets/images/video-play/network-bg.png");
  background-size: 100% 100%;
  background-color: #edfff5;
  .tips {
    font-weight: 600;
    font-size: 20px;
    color: #0d1400;
    line-height: 28px;
    margin-bottom: 40px;
  }
  .operate-wrap {
    display: flex;
    align-items: center;
  }
  .test-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 16px;
    color: #00c89d;
    line-height: 26px;
    width: 96px;
    height: 40px;
    border-radius: 9px;
    margin-right: 19px;
    border: 1px solid #00e884;
  }
  .refresh-btn {
    margin-top: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 16px;
    color: #ffffff;
    line-height: 26px;
    width: 120px;
    height: 40px;
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    i {
      font-size: 18px;
      color: #ffffff;
      margin-right: 8px;
    }
    border-radius: 9px;
  }
}
.custom-player-container {
  position: relative;
  width: 100%;
  height: auto;
  overflow: hidden;
  .video-loading-img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80px;
    height: 80px;
    z-index: 999999999999;
  }
  .custom-mark-title {
    position: absolute;
    right: 65px;
  }
  .replay-cart {
    position: absolute;
    right: 60px;
    bottom: 200px;
    z-index: 9999;
  }
  &.custom-player-container__electron {
    display: flex;
    height: 100%;
    justify-content: center;
  }

  .dplayer-wrapper ::v-deep {
    width: 100%;
    height: auto;
    flex: 1;
    .dplayer-controller {
      display: none;
    }
    .dplayer-notice {
      display: none;
      left: 64px;
      z-index: 99999;
      bottom: 127px;
    }
    .dplayer-bezel-icon {
      display: none;
    }
    .dplayer-menu {
      display: none;
    }
    .dplayer-mobile-play {
      z-index: 9999999999;
    }
  }
  .dplayer-wrapper__full ::v-deep {
    // 为了解决在有些ios上全拼后会遮挡其他元素的问题
    video {
      position: fixed;
      z-index: 1;
    }
  }
  .dplayer-wrapper__show__control ::v-deep {
    .dplayer-mobile-play {
      z-index: 9999999999;
      display: block !important;
      svg {
        display: none !important;
      }
    }
  }
  .play-header {
    position: absolute;
    height: 150px;
    width: 100%;
    z-index: 1;
    left: 0;
    top: -200px;
    background: linear-gradient(
      0,
      rgba(13, 15, 20, 0) 0%,
      rgba(13, 15, 20, 0.9) 100%
    );
    transition: top ease-in-out 0.5s;
    .back-wrap {
      position: absolute;
      left: 62px;
      top: 60px;
      z-index: 1000;
      .back-btn {
        font-size: 20px;
        cursor: pointer;
        color: rgba(42, 177, 138, 1);
        display: flex;
        align-items: center;
        flex-direction: row;
        justify-content: flex-start;
        img {
          width: 24px;
          height: 24px;
          margin-right: 6px;
        }
      }
    }
    .name {
      color: #fff;
      font-weight: 500;
      font-size: 20px;
      color: #ffffff;
      width: 100%;
      margin-top: 60px;
      padding: 0 180px;
      line-height: 28px;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .play-header__show {
    top: 0;
  }
  .play-header__full {
    position: fixed;
    z-index: 9999999;
  }
  .paly-pause-icon-box {
    position: absolute;
    display: none;
    z-index: 9999999;
  }
  .paly-pause-icon-box__show {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -26px 0 0 -26px;
    height: 52px;
    width: 52px;
    padding: 12px;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    opacity: 0.8;
    pointer-events: none;
    animation: scale-hide 0.5s linear;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .logo-container {
    position: absolute;
    right: 64px;
    top: 61px;
    z-index: 1000;
    display: flex;
    flex-direction: row;
    align-items: center;
    .logo {
      width: 22px;
      height: 22px;
    }
    .divider {
      margin: 0 10px;
      width: 1px;
      height: 8px;
      background: #ffffff;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.3);
      border-radius: 2px;
    }
    .org-name {
      font-size: 18px;
      color: #fff;
      text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.3);
      line-height: 25px;
    }
  }
  .logo-container__full {
    position: fixed;
    z-index: 9999999;
  }
  .notice-box {
    position: absolute;
    bottom: 150px;
    height: 30px;
    line-height: 30px;
    padding: 0 15px;
    border-radius: 5px;
    opacity: 0.8;
    color: #fff;
    left: 64px;
    z-index: 99999;
    bottom: 127px;
    background: rgba(28, 28, 28, 0.9);
  }
  .notice-box__full {
    position: fixed;
    z-index: 9999999;
  }
  .player-controls {
    width: 100%;
    height: 200px;
    background: linear-gradient(
      180deg,
      rgba(13, 15, 20, 0) 0%,
      rgba(13, 15, 20, 0.9) 100%
    );
    padding: 0 64px;
    position: absolute;
    bottom: -200px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    transition: bottom ease-in-out 0.5s;
    z-index: 1001;
    .last-play-position {
      width: 100%;
      margin-top: 45px;
      display: flex;
      flex-direction: row;
      height: 28px;
      span {
        font-size: 20px;
        color: #ffffff;
        line-height: 28px;
      }
      .reply-btn {
        font-weight: 600;
        font-size: 20px;
        color: #00c89d;
        line-height: 28px;
        margin-left: 10px;
        cursor: pointer;
      }
    }
    .progress-bar-box {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
      height: 28px;
      margin-top: 12px;
    }
    .other-controls {
      width: 100%;
      height: 33px;
      margin-top: 12px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      img {
        width: 30px;
        cursor: pointer;
      }
      .left,
      .right {
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
      }
      .play-pause-btn,
      .back-btn,
      .forward-btn,
      .cut-btn,
      .speed,
      .operate-item,
      .subtitle-cc-btn-wrap {
        margin-right: 30px;
      }
      .subtitle-cc-btn-wrap {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover svg {
          opacity: 0.8;
        }
      }
    }
  }
  .player-controls__full {
    position: fixed;
    z-index: 9999999;
  }
  .player-controls__show {
    bottom: 0;
  }
}
.custom-player-container__h5 {
  .dplayer-wrapper {
    // z-index: -1;
  }
  .notice-box {
    bottom: 2.4rem;
    height: 0.56rem;
    line-height: 0.56rem;
    padding: 0 0.2rem;
    border-radius: 0.0533rem;
    opacity: 0.8;
    color: #fff;
    left: 0.8533rem;
    z-index: 99999;
    font-size: 0.3rem;
    background: rgba(28, 28, 28, 0.9);
  }
  .play-header {
    position: absolute;
    height: 2.6667rem;
    width: 100%;
    z-index: 1;
    left: 0;
    top: -200px;
    background: linear-gradient(
      0,
      rgba(13, 15, 20, 0) 0%,
      rgba(13, 15, 20, 0.9) 100%
    );
    transition: top ease-in-out 0.5s;
    .back-wrap {
      position: absolute;
      left: 62px;
      top: 60px;
      z-index: 1000;
      .back-btn {
        font-size: 20px;
        cursor: pointer;
        color: rgba(42, 177, 138, 1);
        display: flex;
        align-items: center;
        flex-direction: row;
        justify-content: flex-start;
        img {
          width: 24px;
          height: 24px;
          margin-right: 6px;
        }
      }
    }
    .name {
      color: #fff;
      font-weight: 500;
      font-size: 20px;
      color: #ffffff;
      width: 100%;
      margin-top: 60px;
      padding: 0 180px;
      line-height: 28px;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .logo-container {
    right: 0.3941rem;
    top: 0.3756rem;
    .logo {
      width: 0.4rem;
      height: 0.4rem;
    }
    .divider {
      margin: 0 0.1333rem;
      width: 1px;
      height: 0.2rem;
      background: #ffffff;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.3);
      border-radius: 0.0533rem;
    }
    .org-name {
      font-size: 0.32rem;
      color: #ffffff;
      line-height: 0.56rem;
    }
  }
  .logo-container__full {
    position: fixed;
    z-index: 9999999;
  }
  .player-controls {
    height: 3.3867rem;
    padding: 0 0.8533rem;
    bottom: -3.3867rem;
    .last-play-position {
      margin: 0;
      height: 1.0667rem;
      span {
        font-size: 0.4rem;
        color: #ffffff;
        line-height: 1.6rem;
      }
      .reply-btn {
        font-weight: 600;
        font-size: 0.4rem;
        color: #00c89d;
        line-height: 1.6rem;
        margin-left: 0.2667rem;
        cursor: pointer;
      }
    }
    .progress-bar-box {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
      height: auto;
      margin-top: 0.0493rem;
    }
    .other-controls {
      width: 100%;
      height: 0.56rem;
      margin-top: 0.1867rem;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      img {
        width: 0.5333rem;
        cursor: pointer;
      }

      .play-pause-btn,
      .back-btn,
      .forward-btn,
      .cut-btn,
      .speed {
        margin-right: 0.6667rem;
      }
    }
  }
  .player-controls__full {
    position: fixed;
    z-index: 9999999;
  }
  .player-controls__show {
    bottom: 0;
  }
}
.custom-player-container__landscape {
  .notice-box {
    bottom: 1.25rem;
    height: 0.3125rem;
    line-height: 0.3125rem;
    padding: 0 0.1rem;
    border-radius: 0.0313rem;
    opacity: 0.8;
    color: #fff;
    left: 0.4rem;
    z-index: 99999;
    font-size: 0.1875rem;
    background: rgba(28, 28, 28, 0.9);
  }
  .play-header {
    position: absolute;
    height: 2.6667rem;
    width: 100%;
    z-index: 1;
    left: 0;
    top: -200px;
    background: linear-gradient(
      0,
      rgba(13, 15, 20, 0) 0%,
      rgba(13, 15, 20, 0.9) 100%
    );
    transition: top ease-in-out 0.5s;
    .back-wrap {
      position: absolute;
      left: 62px;
      top: 60px;
      z-index: 1000;
      .back-btn {
        font-size: 20px;
        cursor: pointer;
        color: rgba(42, 177, 138, 1);
        display: flex;
        align-items: center;
        flex-direction: row;
        justify-content: flex-start;
        img {
          width: 24px;
          height: 24px;
          margin-right: 6px;
        }
      }
    }
    .name {
      color: #fff;
      font-weight: 500;
      font-size: 20px;
      color: #ffffff;
      width: 100%;
      margin-top: 60px;
      padding: 0 180px;
      line-height: 28px;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .logo-container {
    right: 0.3941rem;
    top: 0.3756rem;
    .logo {
      width: 0.25rem;
      height: 0.25rem;
    }
    .divider {
      margin: 0 0.1333rem;
      width: 1px;
      height: 0.2rem;
      background: #ffffff;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.3);
      border-radius: 0.0533rem;
    }
    .org-name {
      font-size: 0.1875rem;
      color: #ffffff;
      line-height: 0.56rem;
    }
  }
  .logo-container__full {
    position: fixed;
    z-index: 9999999;
  }
  .player-controls {
    height: 1.5875rem;
    padding: 0 0.4rem;
    bottom: -1.5875rem;
    .last-play-position {
      margin: 0;
      height: 0.5rem;
      span {
        font-size: 0.1875rem;
        color: #ffffff;
        line-height: 0.5rem;
      }
      .reply-btn {
        font-weight: 600;
        font-size: 0.1875rem;
        color: #00c89d;
        line-height: 0.5rem;
        margin-left: 0.125rem;
        cursor: pointer;
      }
    }
    .progress-bar-box {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
      height: auto;
      margin-top: 0.0493rem;
    }
    .other-controls {
      width: 100%;
      height: 0.3125rem;
      margin-top: 0.125rem;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      img {
        width: 0.25rem;
        cursor: pointer;
      }

      .play-pause-btn,
      .back-btn,
      .forward-btn,
      .cut-btn,
      .speed {
        margin-right: 0.3125rem;
      }
    }
  }
  .player-controls__full {
    position: fixed;
    z-index: 9999999;
  }
  .player-controls__show {
    bottom: 0;
  }
}
.custom-player-container__component {
  height: 100%;
  .dplayer-wrapper {
    height: 100% !important;
  }
}
// 放大隐藏动画
@keyframes scale-hide {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}

// electron
.custom-player-container__electron {
  ::v-deep .dplayer.dplayer-loading .dplayer-bezel .diplayer-loading-icon {
    display: none !important;
  }
}
.electron-play-header {
  -webkit-app-region: drag;
  position: absolute;
  height: 90px;
  width: 100%;
  z-index: 1;
  left: 0;
  top: -200px;
  background: linear-gradient(
    0,
    rgba(13, 15, 20, 0) 0%,
    rgba(13, 15, 20, 0.9) 100%
  );
  transition: top ease-in-out 0.5s;

  ::v-deep .tool-bar {
    position: absolute;
    &.mac-bars {
      left: 15px;
      top: 30px;
    }
    &.win-bars {
      right: 20px;
      top: 30px;
    }
  }
  .name {
    width: 100%;
    margin-top: 26px;
    padding: 0 250px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    font-weight: 500;
    font-size: 20px;
    color: #ffffff;
    line-height: 28px;
  }

  .top-btn,
  .network-test-btn {
    -webkit-app-region: none;
    width: 30px;
    height: 30px;
    margin-right: 24px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .operate-wrap {
    position: absolute;
    right: 0;
    top: 25px;
    &.is-win {
      right: 120px;
    }
  }
}
.play-header__show {
  top: 0;
}
.play-header__full {
  position: fixed;
  z-index: 9999999;
}
</style>
<style lang="scss">
.replay-landscape {
  .replay-cart {
    position: absolute;
    right: 60px;
    bottom: 130px;
    z-index: 2100;
  }
}
.page-container__full {
  .replay-cart {
    z-index: 99999999 !important;
  }
}
</style>
